import React, { useEffect, useContext } from 'react';

import {
    LinearProgress,
    Grid
} from '@material-ui/core';

import {
    PageHeader
} from '../../../common';

import {
    RoleList
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../../contexts';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    root: {
    }
});

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy,
        getRolesAsync
    } = useContext(PageContext);

    const {
        navigateTo
    } = useContext(NavContext);

    const {
        roles
    } = state;

    const viewRoleHandler = (role) => {
        navigateTo(NavRoutes.Admin.Role, [role.applicationRoleId]);
    }

    const manageUsersHandler = (role) => {
        navigateTo(NavRoutes.Admin.RoleUsers, [role.applicationRoleId]);
    }

    useEffect(() => {
        getRolesAsync(false, false);
    }, []);

    useEffect(() => {
        setPageIsReady(roles !== null)
    }, [roles])    

    return (
        <>
            {pageIsReady ?                
                <Grid container spacing={3} className={classes.root}>
                    <Grid item xs={12}>
                        <PageHeader
                            title="Roles"
                            subtitle="Roles and users management"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <RoleList
                            onViewRole={viewRoleHandler}
                            onManageUsers={manageUsersHandler}
                        />
                    </Grid>
                </Grid>
                :
                <LinearProgress />
            }
        </>
    );
}

export const RolesPage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}